import React from "react";
import { Link } from "react-router-dom";
import "../../styles/NotFound.css";

export default function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <div className="not-found-divider"></div>
        <div className="not-found-message">
          <h2>Страница не найдена</h2>
          <p>
            Извините, но страница, которую вы ищете, не существует или была
            перемещена.
          </p>
        </div>
        <Link to="/" className="not-found-button">
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
}
